export {
  useChangePasswordMutation,
  useLogoutMutation,
  useMeQuery,
  useRefreshSessionMutation,
} from './api/authApi';
export { GuestOnly, RequireAuth, RequirePage, RequirePasswordFresh } from './components/guards';
export { SessionGate } from './components/SessionGate';
export { safeNext, ssoErrorMessage } from './ssoErrors';

// Pages are lazy-loaded by the router.
export const authPages = {
  login: () => import('./pages/LoginPage'),
  forgot: () => import('./pages/ForgotPasswordPage'),
  reset: () => import('./pages/ResetPasswordPage'),
  change: () => import('./pages/ChangePasswordPage'),
  callback: () => import('./pages/AuthCallbackPage'),
  chooseYear: () => import('./pages/ChooseYearPage'),
  terms: () => import('./pages/TermsPage'),
  privacy: () => import('./pages/PrivacyPage'),
};
